import React from "react";
import ProjectCard from "./ProjectCard";
import projectsData from "../../data/projectsData";

const ProjectGrid = () => {
  return (
    <section className="oglitz-section light">
      <div className="oglitz-project-grid-wrapper">
        {/* Header */}
        <div className="oglitz-project-grid-header">
          <h2 className="oglitz-section-title">Our Work & Case Highlights</h2>
          <p className="oglitz-section-subtitle">
            We partner with startups, enterprises, and global brands to design
            and engineer scalable digital products. Below is a selection of our
            recent projects showcasing strategy, technology, and execution
            excellence.
          </p>
        </div>

        {/* Grid */}
        <div className="oglitz-project-grid">
          {projectsData.map((project, index) => (
            <ProjectCard key={index} project={project} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectGrid;
